import AuthDataFormLayout from "../../components/Layout/AuthDataFormLayout";
import AutomaticDataForm from "../../components/Auth/AutomaticDataForm";

const AutomaticData = () => {
  return (
    <AuthDataFormLayout>
      <AutomaticDataForm />
    </AuthDataFormLayout>
  );
};

export default AutomaticData;
